<template>
  <div class="tw:flex tw:gap-4" v-if="start && end">
    <div class="tw:flex-none">
      <CalendarDays stroke-width="1" class="tw:size-12 tw:text-zinc-500" />
    </div>

    <div class="tw:min-w-0 tw:flex-1">
      <h3 class="tw:m-0 tw:text-base">
        <template v-if="isSameDay">
          {{ start.format("dddd LL") }}
        </template>
        <template v-else>
          <span class="tw:inline-flex tw:items-center tw:gap-1.5">
            {{ start.format("ll") }}
            <ArrowRight class="tw:size-4 tw:flex-none tw:text-zinc-400" />
            {{ end.format("ll") }}
          </span>
        </template>
      </h3>

      <div class="tw:mt-0.5 tw:flex tw:items-center tw:gap-1.5 tw:text-zinc-500">
        <Clock class="tw:size-4 tw:flex-none" />
        {{ start.format("LT") }}
        <ArrowRight class="tw:size-4 tw:flex-none tw:text-zinc-400" />
        {{ end.format("LT") }}
      </div>

      <div v-if="stageName" class="tw:text-zinc-500">
        {{ $t("Stage") }} : {{ stageName }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import dayjs from "dayjs";
import { ArrowRight, CalendarDays, Clock } from "@lucide/vue";

const props = defineProps({
  booking: {
    type: Object,
    required: true
  },
  mode: {
    type: String,
    required: true
  }
});

/** In slot mode the period belongs to the slot; every other mode carries it on the booking. */
const period = computed(() => (
  props.mode === "slot"
    ? props.booking?.booking_slot
    : props.booking
));

const start = computed(() => {
  const value = period.value?.start_at;
  return value ? dayjs(value) : null;
});

const end = computed(() => {
  const value = period.value?.end_at;
  return value ? dayjs(value) : null;
});

// A slot usually sits inside one day, a free date booking usually spans several: show the days
// only once when they are the same, rather than repeating the same date on both sides of an arrow.
const isSameDay = computed(() => Boolean(start.value && end.value && start.value.isSame(end.value, "day")));

const stageName = computed(() => (
  props.mode === "slot"
    ? props.booking?.booking_slot?.stage?.name
    : null
));
</script>
